(function () {
  "use strict";

  var YOUTUBE_CONSENT_GROUP = 'C0004';

  function activeGroupsInclude(group) {
    if (typeof window.OnetrustActiveGroups !== 'string') return false;
    return window.OnetrustActiveGroups.split(',').filter(Boolean).indexOf(group) !== -1;
  }

  function isBannerAnswered() {
    // window.OnetrustActiveGroups reflects a pre-interaction default (often all groups granted) while the
    // banner is still open; only trust it once the banner has actually been closed/answered by the visitor.
    // If there's no banner in the DOM at all, consent was already resolved (e.g. implied-consent regions).
    var banner = document.getElementById('onetrust-banner-sdk');
    if (!banner) return true;

    return getComputedStyle(banner).display === 'none';
  }

  function hasAcceptedYouTubeCookies() {
    if (window.__consentVendorGate && typeof window.__consentVendorGate.isAllowed === 'function') {
      if (window.__consentVendorGate.isAllowed('youtube')) return true;
    }

    // window.OnetrustActiveGroups is kept in sync by OneTrust and is more reliable than the
    // OptanonConsent cookie, which can fail to be set (SameSite/third-party cookie restrictions, previews, etc.)
    if (typeof window.OnetrustActiveGroups === 'string') {
      return isBannerAnswered() && activeGroupsInclude(YOUTUBE_CONSENT_GROUP);
    }

    // Fallback: parse the persisted OneTrust cookie; groups=C0001:1,C0002:0,...
    var match = document.cookie.match(/(?:^|; )OptanonConsent=([^;]*)/);
    if (!match) return false;

    var cookie;
    try {
      cookie = decodeURIComponent(match[1]);
    } catch (error) {
      cookie = match[1];
    }

    // interactionCount=0 means the banner defaults haven't been confirmed by a real user action yet;
    // some OneTrust setups pre-populate groups as granted by default, so that snapshot can't be trusted
    var interactionMatch = cookie.match(/interactionCount=(\d+)/);
    var interactionCount = interactionMatch ? parseInt(interactionMatch[1], 10) : 0;
    if (!interactionCount) return false;

    var groupsMatch = cookie.match(/groups=([^&]*)/);
    if (!groupsMatch) return false;

    return new RegExp('(^|,)' + YOUTUBE_CONSENT_GROUP + ':1(,|$)').test(groupsMatch[1]);
  }

  function buildEmbedSrc(container) {
    var videoId = container.getAttribute('data-youtube-id');
    if (videoId) {
      return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?enablejsapi=1&rel=0&autoplay=0';
    }

    return container.getAttribute('data-embed-src');
  }

  function acceptYouTubeCookies(callback) {
    if (hasAcceptedYouTubeCookies()) {
      callback();
      return;
    }

    if (typeof window.OneTrust !== 'undefined' && typeof window.OneTrust.UpdateConsent === 'function') {
      try {
        window.OneTrust.UpdateConsent('Category', YOUTUBE_CONSENT_GROUP + ':1');
      } catch (error) {
        return;
      }
      window.dispatchEvent(new CustomEvent('OneTrustGroupsUpdated', { detail: [YOUTUBE_CONSENT_GROUP] }));
      window.setTimeout(function () {
        callback();
      }, 300);
      return;
    }

    if (typeof window.OneTrust !== 'undefined' && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
      window.OneTrust.ToggleInfoDisplay();
    }
  }

  function injectIframe(container) {
    if (!container || container.getAttribute('data-loaded') === 'true') return;

    var src = buildEmbedSrc(container);
    if (!src) return;

    container.setAttribute('data-loaded', 'true');

    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = container.getAttribute('data-title') || 'YouTube video';
    iframe.frameBorder = '0';
    iframe.allow = container.getAttribute('data-allow') || '';
    iframe.allowFullscreen = true;
    iframe.className = container.getAttribute('data-iframe-class') || 'w-full h-full';

    var slideContainer = container.closest('.swiper-slide');
    var loader = slideContainer ? slideContainer.querySelector('.loader') : container.querySelector('.loader');
    if (loader) {
      loader.style.display = 'block';
      iframe.addEventListener('load', function () {
        loader.style.display = 'none';
      });
    }

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) playButton.style.display = 'none';

    container.appendChild(iframe);
    container.dispatchEvent(new CustomEvent('youtube-click-to-load:loaded', { bubbles: true, detail: { iframe: iframe } }));
  }

  function resetContainer(container) {
    var iframe = container.querySelector('iframe');
    if (iframe) iframe.remove();
    container.setAttribute('data-loaded', 'false');

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) playButton.style.display = '';

    var loader = container.querySelector('.loader');
    if (loader) loader.style.display = 'none';
  }

  function loadAfterConsentSettles(container) {
    window.setTimeout(function () {
      if (hasAcceptedAnyCookies()) injectIframe(container);
    }, 1200);
  }

  function initContainer(container) {
    if (container.getAttribute('data-initialized') === 'true') return;
    container.setAttribute('data-initialized', 'true');

    loadAfterConsentSettles(container);

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) {
      playButton.addEventListener('click', function () {
        acceptYouTubeCookies(function () { injectIframe(container); });
      });
    }

    // Stay on the placeholder until the user accepts at least one cookie category, then auto-load
    window.addEventListener('OneTrustGroupsUpdated', function onConsentUpdate() {
      if (hasAcceptedYouTubeCookies()) {
        injectIframe(container);
        return;
      }

      resetContainer(container);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-youtube-click-to-load]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support embeds added after initial load (e.g. swiper slides rendered dynamically)
  document.addEventListener('youtube-click-to-load:refresh', initAll);
})();
